import React from 'react';
import { useListingTypesConfig } from 'hooks';

export default Component => props => (
    <Component {...props} listingTypes={useListingTypesConfig()} />
);
